import React from 'react';

const Modal = ({ open, onClose, children, maxWidth = 1200 }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,.65)', backdropFilter: 'blur(4px)',
        display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
        paddingTop: '40px', zIndex: 1000, overflowY: 'auto', paddingBottom: 40
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: 16, width: '95%', maxWidth,
          boxShadow: '0 25px 80px rgba(0,0,0,.3)',
          animation: 'modalIn .25s ease'
        }}
        onClick={e => e.stopPropagation()}
      >
        <style>{`@keyframes modalIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
        {children}
      </div>
    </div>
  );
};

export const ModalHeader = ({ children, onClose }) => (
  <div style={{
    padding: '20px 24px', borderBottom: '1px solid #eee',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    background: '#fafafa'
  }}>
    <div>{children}</div>
    <button
      onClick={onClose}
      style={{
        width: 36, height: 36, borderRadius: 10, border: 'none',
        background: '#eee', cursor: 'pointer', fontSize: 18,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background .2s', color: '#666'
      }}
      onMouseEnter={e => e.currentTarget.style.background = '#ddd'}
      onMouseLeave={e => e.currentTarget.style.background = '#eee'}
    >✕</button>
  </div>
);

export default Modal;
